import { SelectOption } from "../select/virtualized-select";

export const useVirtualizedDownshiftStateReducer = (opts: {
  options: SelectOption[];
}) => {
  return (state, actionAndChanges) => {
    if (actionAndChanges.type === "__autocomplete_keydown_arrow_down__") {
      const item = opts.options[actionAndChanges.highlightedIndex];
      if (item && item.isGroupHeader) {
        return {
          ...state,
          highlightedIndex: actionAndChanges.highlightedIndex + 1,
        };
      }
    }

    if (actionAndChanges.type === "__autocomplete_keydown_arrow_up__") {
      const item = opts.options[actionAndChanges.highlightedIndex];
      if (item.isGroupHeader) {
        return {
          ...state,
          highlightedIndex: actionAndChanges.highlightedIndex - 1,
        };
      }
    }

    // We need to make sure we don't close the popover or scroll to the top of the list
    // when the user selects an item using the enter key
    if (actionAndChanges.type === "__autocomplete_keydown_enter__") {
      return {
        ...actionAndChanges,
        highlightedIndex: state.highlightedIndex, // use the last highlighted index
      };
    }
    return actionAndChanges;
  };
};
